import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import LANGUAGES from "./supportedLanguages";
import * as AdminCompanyTab from "./AdminCompanyTab/values";
import * as CompanyUserLayout from "./CompanyUserLayout/values";
import * as DashboardPage from "./DashboardPage/values";
import * as EditEmailTemplatePage from "./EditEmailTemplatePage/values";
import * as EditProfilePage from "./EditProfilePage/values";
import * as FeedbackReportView from "./FeedbackReportView/values";
import * as ForgotPasswordPage from "./ForgotPasswordPage/values";
import * as LoginPage from "./LoginPage/values";
import * as DefaultGroupView from "./DefaultGroupView/values";
import * as NormalIndividualQuestionReport from "./NormalIndividualQuestionReport/values";
import * as NormalIndividualView from "./NormalIndividualView/values";
import * as ReportsPage from "./ReportsPage/values";
import * as ReportViewPage from "./ReportViewPage/values";
import * as SettingsPage from "./SettingsPage/values";
import * as SurveyCampaign360Form from "./SurveyCampaign360Form/values";
import * as SurveyCampaignForm from "./SurveyCampaignForm/values";
import * as SurveyCampaignsPage from "./SurveyCampaignsPage/values";
import * as SurveyCampaignView from "./SurveyCampaignView/values";
import * as SurveyResponsePage from "./SurveyResponsePage/values";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    resources: {
      [LANGUAGES.en.nativeName]: {
        translation: {
          ...AdminCompanyTab.englishValues,
          ...CompanyUserLayout.englishValues,
          ...DashboardPage.englishValues,
          ...EditEmailTemplatePage.englishValues,
          ...EditProfilePage.englishValues,
          ...FeedbackReportView.englishValues,
          ...ForgotPasswordPage.englishValues,
          ...LoginPage.englishValues,
          ...DefaultGroupView.englishValues,
          ...NormalIndividualQuestionReport.englishValues,
          ...NormalIndividualView.englishValues,
          ...ReportsPage.englishValues,
          ...ReportViewPage.englishValues,
          ...SettingsPage.englishValues,
          ...SurveyCampaign360Form.englishValues,
          ...SurveyCampaignForm.englishValues,
          ...SurveyCampaignsPage.englishValues,
          ...SurveyCampaignView.englishValues,
          ...SurveyResponsePage.englishValues,
        },
      },
      [LANGUAGES.my.nativeName]: {
        translation: {
          ...AdminCompanyTab.malayValues,
          ...CompanyUserLayout.malayValues,
          ...DashboardPage.malayValues,
          ...EditEmailTemplatePage.malayValues,
          ...EditProfilePage.malayValues,
          ...FeedbackReportView.malayValues,
          ...ForgotPasswordPage.malayValues,
          ...LoginPage.malayValues,
          ...DefaultGroupView.malayValues,
          ...NormalIndividualQuestionReport.malayValues,
          ...NormalIndividualView.malayValues,
          ...ReportsPage.malayValues,
          ...ReportViewPage.malayValues,
          ...SettingsPage.malayValues,
          ...SurveyCampaign360Form.malayValues,
          ...SurveyCampaignForm.malayValues,
          ...SurveyCampaignsPage.malayValues,
          ...SurveyCampaignView.malayValues,
          ...SurveyResponsePage.malayValues,
        },
      },
      [LANGUAGES.cnSimplified.nativeName]: {
        translation: {
          ...AdminCompanyTab.chineseSimplifiedValues,
          ...CompanyUserLayout.chineseSimplifiedValues,
          ...DashboardPage.chineseSimplifiedValues,
          ...EditEmailTemplatePage.chineseSimplifiedValues,
          ...EditProfilePage.chineseSimplifiedValues,
          ...FeedbackReportView.chineseSimplifiedValues,
          ...ForgotPasswordPage.chineseSimplifiedValues,
          ...LoginPage.chineseSimplifiedValues,
          ...DefaultGroupView.chineseSimplifiedValues,
          ...NormalIndividualQuestionReport.chineseSimplifiedValues,
          ...NormalIndividualView.chineseSimplifiedValues,
          ...ReportsPage.chineseSimplifiedValues,
          ...ReportViewPage.chineseSimplifiedValues,
          ...SettingsPage.chineseSimplifiedValues,
          ...SurveyCampaign360Form.chineseSimplifiedValues,
          ...SurveyCampaignForm.chineseSimplifiedValues,
          ...SurveyCampaignsPage.chineseSimplifiedValues,
          ...SurveyCampaignView.chineseSimplifiedValues,
          ...SurveyResponsePage.chineseSimplifiedValues,
        },
      },
      [LANGUAGES.cnTraditional.nativeName]: {
        translation: {
          ...AdminCompanyTab.chineseTraditionalValues,
          ...CompanyUserLayout.chineseTraditionalValues,
          ...DashboardPage.chineseTraditionalValues,
          ...EditEmailTemplatePage.chineseTraditionalValues,
          ...EditProfilePage.chineseTraditionalValues,
          ...FeedbackReportView.chineseTraditionalValues,
          ...ForgotPasswordPage.chineseTraditionalValues,
          ...LoginPage.chineseTraditionalValues,
          ...DefaultGroupView.chineseTraditionalValues,
          ...NormalIndividualQuestionReport.chineseTraditionalValues,
          ...NormalIndividualView.chineseTraditionalValues,
          ...ReportsPage.chineseTraditionalValues,
          ...ReportViewPage.chineseTraditionalValues,
          ...SettingsPage.chineseTraditionalValues,
          ...SurveyCampaign360Form.chineseTraditionalValues,
          ...SurveyCampaignForm.chineseTraditionalValues,
          ...SurveyCampaignsPage.chineseTraditionalValues,
          ...SurveyCampaignView.chineseTraditionalValues,
          ...SurveyResponsePage.chineseTraditionalValues,
        },
      },
    },
    fallbackLng: LANGUAGES.en.nativeName,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
